module.exports = __webpack_public_path__ + "img/plavi.b6dd76cb.png";